import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { Section } from '../../../models';
import { field } from '../../../core/field-schema';
import { required, maxLength, pattern } from '../../../core/validator-builders';
import { FlumeInstallationFieldIds, InstallationConfigState, InstallationTypeSectionIds } from '../../common.models';

export const getValidators = function (isMetric: boolean) {
    const validators = [required(), maxLength({ value: 100 })];

    if (isMetric) {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationMetricValuePattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR_METRIC',
            }),
        ];
    } else {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationValuePattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR',
            }),
        ];
    }
};

export const getFlowValidators = function (isMetric: boolean) {
    const validators = [required(), maxLength({ value: 100 })];

    if (isMetric) {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationMetricValuePattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR_METRIC',
            }),
        ];
    } else {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.installationValue3DecimalPattern,
                message: 'COMMON.NUMERIC_PRECISION_ERROR_3_DECIMALS',
            }),
        ];
    }
};

// Flume installation type configuration (Series 400)
export const flumeInstallationConfig = (state: InstallationConfigState): Section => {
    const settings = state.settings;
    const details = state.locationDetails && state.locationDetails.length > 0 ? state.locationDetails[0] : null;

    const FieldIds = FlumeInstallationFieldIds;

    return {
        info: {
            id: InstallationTypeSectionIds.Flume,
            title: '',
            displayTitle: false,
        },
        rows: [
            {
                info: {
                    id: 'flume-parameters-row',
                    panelClass: 'custom-33p',
                },
                items: [
                    field.number(FieldIds.Range, 'range', {
                        value: details ? details.range : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.RAIN_PLACEHOLDER',
                        placeholderSuffix: settings.depthUnit,
                        validators: getValidators(settings.isMetric),
                        panelClass: 'each-Item pad-t-6 width-30 required',
                    }),
                    field.number(FieldIds.Capacity, 'capacity', {
                        value: details ? details.capacity : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.CAPACITY_PLACEHOLDER',
                        placeholderSuffix: settings.flowUnit,
                        validators: getFlowValidators(settings.isMetric),
                        panelClass: 'each-Item pad-t-6 width-30 required',
                    }),
                    field.number(FieldIds.Width, 'width', {
                        value: details ? details.width : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.WIDTH',
                        placeholderSuffix: settings.depthUnit,
                        validators: getValidators(settings.isMetric),
                        panelClass: 'each-Item pad-t-6 width-30',
                    }),
                ],
            },
        ],
    };
};
